module.exports = __webpack_public_path__ + "static/media/start.d83c517e.mp3";